import { createReducer } from 'redux-act';

import { databaseSelected } from './actions';

export default createReducer({
  [databaseSelected]: (_state, name) => name,
}, null);
